import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { manageTranslations as TranslationHelper } from '@morsedigital/i18n_helper';

import ButtonsHelper from '../helpers/buttons_process';

const wp = TranslationHelper('javascript')('weekly_programme');

function checkAlert(text) {
  return !_.isEmpty(text);
}

function checkBook(url) {
  return !_.isEmpty(url); // && url !== '#';
}

function checkPlaces(places) {
  return _.isNumber(places) && places === 0;
}

const BookBtn = ({ session }) => {
  const { instruction, link, places, title, book_alert } = ButtonsHelper(session);
  if (instruction) {
    return <span className="session-full">{instruction}</span>;
  }

  if (checkPlaces(places)) {
    return <span className="session-full">{wp('additional.session_full')}</span>;
  }

  if (checkBook(link)) {
    if (checkAlert(book_alert)) {
      return (
        <a className="call-to-action call-to-action--primary" href={link} data-confirm={book_alert}>
          {title}
        </a>
      );
    }
    return (
      <a className="call-to-action call-to-action--primary" href={link}>
        {title}
      </a>
    );
  }

  return <span className="session-full">{wp('additional.no_booking')}</span>;
};

BookBtn.propTypes = {
  session: PropTypes.object.isRequired,
};

export default BookBtn;
